import type { FaireProductEntity } from "../../entity_types/product";

export const p_ug24bt6h8h: FaireProductEntity = {
  token: "p_ug24bt6h8h",
  type: "product",
  name: "Rye Highball Glass / Water Glass Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/8bb2e1c280dc4f237b1ab152db3655252378652aed71460a35b3aff2ae90de91.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/13e1d51825432564be2614878afc99f4ae6035b07dcf65ac6b9cf5aebc041bd4.jpeg",
    "https://cdn.faire.com/fastly/e28b349605b4afa1de4147d8e4d6750dd38276f60c9f77b9cb1373065b1d0049.jpeg",
    "https://cdn.faire.com/fastly/2f88c78ed97ab393de926bec254613aeb953cb59fc64fd8a7cf2e63ed306c7c7.jpeg",
    "https://cdn.faire.com/fastly/5d22effc5329ea5f86810426628f6ad2c663a4fc0551b32e95554ac0050f109a.jpeg",
    "https://cdn.faire.com/fastly/436c06a9d5c8764c84f6c0dcab645b9e04e38b560bc55cf7caae127fba64d5b2.jpeg",
  ],
  priceDollars: 26.25,
  description:
    'RYE glassware range has been designed to elevate the drinking experience, whether it is water, beer, wine or a meticulously mixed cocktail. The glasses are skilfully hand crafted from a robust borosilicate glass. The range is well-proportioned, graphic in form, and the subtle accent of coloured glass elevates the drink whilst still allowing you to appreciate the shade of the drink.\n\nThis size is perfect for your favourite cocktails and soft drinks.\n\n• Packed as a set of 2.\n• Size: D 2.7" x H 5.9"\n• Capacity: 440ml / 15 fl oz\n\n• Colour: clear + smoke',
  tags: [],
  msrpDollars: 52.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:28.133Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
